import React from 'react';
import { CalendarDays, RefreshCw, ShieldCheck } from 'lucide-react';

export default function DashboardHeader() {
  return (
    <div className="flex items-start justify-between flex-wrap gap-3">
      <div>
        <h1 className="text-2xl font-600 text-foreground tracking-tight">Payroll Dashboard</h1>
        <p className="text-sm text-muted-foreground mt-0.5">
          Pay period: <span className="font-500 text-foreground">28 Apr – 04 May 2026</span>
          <span className="mx-2 text-border">·</span>
          Week 18 of 2026
          <span className="mx-2 text-border">·</span>
          <span className="font-500 text-foreground">Sunrise Care Agency Ltd</span>
        </p>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <div className="flex items-center gap-1.5 text-[11px] font-600 text-success bg-success/8 border border-success/20 rounded-lg px-2.5 py-2">
          <ShieldCheck size={12} />
          <span>NLW £12.21/hr · Compliant</span>
        </div>
        <div className="flex items-center gap-1.5 text-[12px] font-500 text-muted-foreground bg-card border border-border rounded-lg px-3 py-2">
          <span className="font-600 text-foreground">2025/26</span>
          <span>Tax Year</span>
        </div>
        <div className="flex items-center gap-1.5 text-[12px] text-muted-foreground bg-card border border-border rounded-lg px-3 py-2">
          <CalendarDays size={13} />
          <span>Week ending 04 May 2026</span>
        </div>
        <div className="flex items-center gap-1.5 text-[11px] text-muted-foreground">
          <RefreshCw size={11} />
          <span>Updated 07:18</span>
        </div>
      </div>
    </div>
  );
}